var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.checkup ? _c('page-content', {
    attrs: {
      "title": "Konsultasi Psikologi: Detail Riwayat",
      "with-margin": false,
      "back-button": ""
    }
  }, [_c('br'), _c('survey-alert', {
    staticClass: "mx-3 mb-1"
  }), _c('simple-list', {
    attrs: {
      "label": "Hal yang akan dikonsultasikan",
      "text": _vm.checkup.problem
    }
  }), _c('simple-list', {
    attrs: {
      "label": "Jadwal Konsultasi",
      "text": _vm.getScheduleOptionText(_vm.checkup.schedule.day, _vm.checkup.schedule.time_start, _vm.checkup.schedule.time_end)
    }
  }), _c('simple-list', {
    attrs: {
      "label": "Status"
    }
  }, [_c('div', {
    staticClass: "mt-1 d-flex align-items-center flex-wrap"
  }, [_c('span', {
    staticClass: "badge mr-1 mb-1",
    class: _vm.getCheckupBadge(_vm.checkup.status)
  }, [_vm._v("\n        " + _vm._s(_vm.capitalize(_vm.getCheckupStatusIndo(_vm.checkup.status))) + "\n      ")]), ['scheduled', 'completed'].includes(_vm.checkup.status) ? [_c('span', {
    staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "event",
      "type": "rounded",
      "size": "12"
    }
  }), _vm._v("\n          " + _vm._s(_vm.formatDateForHuman(_vm.checkup.scheduled_at, true)) + "\n        ")], 1), _c('span', {
    staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "schedule",
      "type": "rounded",
      "size": "12"
    }
  }), _vm._v("\n          " + _vm._s(_vm.formatTimeToIndo(_vm.checkup.schedule.time_start)) + " -\n          " + _vm._s(_vm.formatTimeToIndo(_vm.checkup.schedule.time_end)) + " WIB\n        ")], 1), _c('span', {
    staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "chair",
      "type": "outlined",
      "size": "12"
    }
  }), _vm._v("\n          " + _vm._s(_vm.checkup.room.name) + "\n        ")], 1)] : _vm._e()], 2), _vm.checkup.status == 'unscheduled' ? _c('small', {
    staticClass: "d-flex align-items-start mt-2"
  }, [_vm._v("\n      Harap menunggu, petugas akan mengatur jadwal dan menghubungi saudara.\n    ")]) : _vm._e()]), _c('div', {
    staticClass: "m-3"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v("Skrining")]), _c('div', {
    staticClass: "card px-0"
  }, _vm._l(_vm.checkup.screenings, function (screening, index) {
    return _c('simple-list', {
      key: index,
      attrs: {
        "label": screening.question,
        "text": screening.answer
      }
    });
  }), 1)]), _vm.checkup.status == 'completed' ? _c('div', {
    staticClass: "mt-3 mx-3"
  }, [_c('h4', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n      Solusi/rekomendasi dari psikolog\n    ")]), _c('div', {
    staticClass: "card card-success text-white mt-1"
  }, [_c('div', {
    staticClass: "unreset"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkup.suggestion)
    }
  })]), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "background": "rgba(255, 255, 255, 0.4)"
    }
  }), _c('div', {
    staticClass: "d-flex gap-1"
  }, [_vm.checkup.is_reffered == '1' ? _c('span', {
    staticClass: "d-inline-flex align-items-center badge badge-warning"
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "gpp_good",
      "size": "16"
    }
  }), _vm._v("\n          Dirujuk\n        ")], 1) : _vm._e(), _c('span', {
    staticClass: "d-inline-flex align-items-center badge badge-primary"
  }, [_c('material-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "assignment_ind",
      "size": "16"
    }
  }), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("Psikolog:")]), _c('b', [_vm._v(_vm._s(_vm.checkup.psychologist))])], 1)])])]) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }